import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import SocialContact from "./SocialContact";
import { useMediaQuery, useTheme } from "@mui/material";
import LanguageSelector from "./LanguageSelector";
import { Stack } from "@mui/material";
import Copyright from "./Copyright";
import { socialLinks } from "../pages";

export default function StickyFooter() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto', // This pushes the footer to the bottom when there's extra space
        backgroundColor: (theme) =>
          theme.palette.mode === "light"
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Copyright />
        <Stack direction="row" spacing={2}>
          <SocialContact links={socialLinks} />
          {isMobile && <LanguageSelector />}
        </Stack>
      </Container>
    </Box>
  );
}
